import { Next } from '@securitize/ui-components';

export const GET_OPPORTUNITY_WIZARD_NEXT = (opportunityId) => new Next(`/opportunities/${opportunityId}/wizard`,
  'GET_OPPORTUNITY_WIZARD_NEXT');

export const RESET_OPPORTUNITY_WIZARD_ACTION = 'RESET_OPPORTUNITY_WIZARD_ACTION';
